export const OnlyBasicFieldsHaveEventsError = new Error('only basic fields have change events');
